import apiConfig from 'constants/apiConfig';
import {
    DiscoverCreatorsResponse,
    DiscoveredCreatorItem,
    DiscoveredCreatorsResponse,
    DiscoveryCreatorFilters,
    DiscoveryCreatorSort,
    DiscoveryDetails,
    RecentDiscoveriesResponse,
} from 'types/creator-discovery';
import axiosClient from 'utils/axiosClient';

const withDiscoveryId = (url: string, discoveryId: string) => url.replace('<discoveryId>', discoveryId);

const withAgencyId = (url: string, agencyId: string) => url.replace('<agencyId>', agencyId);
export const discoverCreators = async (agencyId: string, query: string): Promise<DiscoverCreatorsResponse> => {
    const response = await axiosClient.post(withAgencyId(apiConfig.DISCOVER_CREATORS.url, agencyId), { query });
    return response.data;
};

export const fetchCreatorDiscoveryDetails = async (agencyId: string, discoveryId: string): Promise<DiscoveryDetails> => {
    const response = await axiosClient.get(withDiscoveryId(withAgencyId(apiConfig.FETCH_CREATOR_DISCOVERY_DETAILS.url, agencyId), discoveryId));
    return response.data;
};

export const fetchDiscoveredCreators = async (
    agencyId: string,
    discoveryId: string,
    page = 1,
    sort: DiscoveryCreatorSort = 'rank',
    limit?: number,
    filters?: DiscoveryCreatorFilters
): Promise<DiscoveredCreatorsResponse> => {
    console.log('filters', {
        page,
        sort,
        ...(limit !== undefined ? { limit } : {}),
        ...(filters?.followers_count?.min != null || filters?.followers_count?.max != null
            ? {
                followers_count: {
                    ...(filters.followers_count.min != null ? { min: filters.followers_count.min } : {}),
                    ...(filters.followers_count.max != null ? { max: filters.followers_count.max } : {}),
                },
            }
            : {}),
        ...(filters?.engagement_score != null && filters.engagement_score > 0
            ? { engagement_score: filters.engagement_score }
            : {}),
        ...(filters?.gender ? { gender: filters.gender } : {}),
    });
    const response = await axiosClient.get(withDiscoveryId(withAgencyId(apiConfig.FETCH_DISCOVERED_CREATORS.url, agencyId), discoveryId), {
        params: {
            page,
            sort,
            ...(limit !== undefined ? { limit } : {}),
            ...(filters?.followers_count?.min != null || filters?.followers_count?.max != null
                ? {
                    followers_count: {
                        ...(filters.followers_count.min != null ? { min: filters.followers_count.min } : {}),
                        ...(filters.followers_count.max != null ? { max: filters.followers_count.max } : {}),
                    },
                }
                : {}),
            ...(filters?.engagement_score != null && filters.engagement_score > 0
                ? { engagement_score: filters.engagement_score }
                : {}),
            ...(filters?.gender ? { gender: filters.gender } : {}),
        },
    });
    return response.data;
};

export const fetchRecentDiscoveries = async (
    agencyId: string,
    page = 1,
    q?: string
): Promise<RecentDiscoveriesResponse> => {
    const response = await axiosClient.get(withAgencyId(apiConfig.RECENT_DISCOVERIES.url, agencyId), {
        params: {
            page,
            ...(q ? { q } : {}),
        },
    });
    return response.data;
};


export const fetchDiscoveredCreator = async (agencyId: string, discoveryId: string, socialAccountId: string): Promise<DiscoveredCreatorItem> => {
    const response = await axiosClient.get(withDiscoveryId(withAgencyId(apiConfig.FETCH_DISCOVERED_CREATOR.url, agencyId), discoveryId).replace('<socialAccountId>', socialAccountId));
    return response.data.item as DiscoveredCreatorItem;
}